// tslint:disable: completed-docs
import produce from 'immer';
import {IInitialState} from './types';

import {
    SET_CURRENT_OFFERS_SUCCESS,
    SET_CURRENT_OFFERS,
    SET_CURRENT_OFFERS_FAILED,
    SET_DEFAULT_STATE,
    SET_ADDITIONAL_CONTENT_DOWNLOADED,
} from './constant';

// tslint:disable-next-line: completed-docs
export const initialState: IInitialState = {
    initializing: false,
    error: false,
    currentOffers: false,
    updating: false,
    isDefault: false,
    additionalContentDownloaded: false,
};

/**
 * Update list of simOnly in state or the error in case of API failed
 *
 * @export {function} preDataHandlerReducer
 * @param {*} state - Initial state of the app
 * @param {*} action - The action dispatched from saga
 */
const offerDisplayReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case SET_DEFAULT_STATE:
                draft.initializing = true;
                break;
            case SET_CURRENT_OFFERS:
                draft.error = false;
                draft.updating = true;
                break;
            case SET_CURRENT_OFFERS_SUCCESS:
                draft.initializing = false;
                draft.currentOffers = action.offers;
                draft.isDefault = action.isDefault;
                draft.updating = false;
                break;
            case SET_CURRENT_OFFERS_FAILED:
                draft.error = true;
                draft.updating = false;
                break;
            case SET_ADDITIONAL_CONTENT_DOWNLOADED:
                draft.additionalContentDownloaded = true;
                break;
        }
    });

export default offerDisplayReducer;
